/*
 * @Author: 李修垚 1530465910@qq.com
 * @Date: 2023-10-31 17:24:05
 * @LastEditors: 李修垚 1530465910@qq.com
 * @LastEditTime: 2023-11-01 11:06:14
 * @FilePath: \s-pages\src\api\housing_registration_inquiry.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../utils/request';
import RestUrl from '../config/rest-url';

export const GetContractInfo = (data) => {
  return request.request({
    url: RestUrl.zhfc.contractInfo,
    // url: 'https://admin.zhfc.wnxbdcdjzx.com/api/zhfc/portal/contractlnfo',
    method: 'post',
    data: data,
  });
};
